<template>
  <div class="unlimited">
      <div class="yadokari-title">第1回全国統一やどかり模試</div>
      <section class="unlimited-keyvisual">
        <section class="unlimited-keyvisual__contents unlimited-intro">
        </section>
        <div class="video-wrapper">
          <video class="video-player" v-bind:poster="require('../../../../static/img/yadokari-moshi-sam.png')" preload="none" controls>
            <source v-bind:src="require('../../../../static/video/yadokari-moshi.mp4')" type="video/mp4;">
            <source v-bind:src="require('../../../../static/video/yadokari-moshi.webm')" type="video/webm;">
          </video>
        </div>
      </section>
      <main class="unlimited-main">
        <span class="yadokari-bold">概要：</span><br>
        日程&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2019/5/19（日）12:30-17:30<br>
        講師&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;神崎 正哉<br>
        参加費&nbsp;&nbsp;&nbsp;¥1,000<br>
        特典&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;abceed版『TOEIC L&R TEST 標準模試 2』<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*840円相当<br><br>

        <span class="yadokari-bold">会場情報（会場で受験の場合）：</span><br>
        会場&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;T’z 英語ラウンジ<br>
        住所&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;東京都世田谷区南烏山５丁目２３−９<br>
        地図&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href="http://tz-eigolounge.jp/access/">http://tz-eigolounge.jp/access/</a><br>
        <br>
        <span class="yadokari-bold">当日のスケジュール：</span><br>
        12:00-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;開場<br>
        12:30-12:45&nbsp;&nbsp;&nbsp;&nbsp;ライブ動画放映開始・事前アナウンス<br>
        12:45-13:00&nbsp;&nbsp;&nbsp;&nbsp;休憩・準備<br>
        13:00-15:00&nbsp;&nbsp;&nbsp;&nbsp;テスト時間（200問）<br>
        15:00-15:15&nbsp;&nbsp;&nbsp;&nbsp;abceedへ解答入力 & 休憩<br>
        15:15-17:10&nbsp;&nbsp;&nbsp;&nbsp;結果発表&解説講義<br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*正答率の低い30問を中心に<br>
        17:10-17:30&nbsp;&nbsp;&nbsp;&nbsp;Q&A<br>
        <br>

        <span class="yadokari-bold">事前準備：</span><br>
        ・参加申込み<br>
        ・「TOEIC L&R TEST 標準模試 2(紙の書籍)」の購入<br>
        *各自お近くの書店にてお買い求めください。<br>
        Amazon URL: <a href="https://www.amazon.co.jp/dp/4794604661">https://www.amazon.co.jp/dp/4794604661</a>
        <br>
        <br>

        <span class="yadokari-bold-pink">Point 1: 全国ランキング＆予測スコア</span><br>
        当日「標準模試2」を解き、解答データをabceedに入力すれば、その場で全国ランキングと本番の予測スコアがわかります。<br>
        <img class="yadokari_creative" v-bind:src="require('../../../../static/img/yadokari_creative_1.png')"><br><br>

        <span class="yadokari-bold-pink">Point 2: 解説講義のライブ配信</span><br>
        テスト後には、「標準模試2」の著者（神崎正哉）による解説講義をYouTubeでライブ配信。<br>
        <img class="yadokari_creative" v-bind:src="require('../../../../static/img/yadokari_creative_2.png')"><br><br>

        <span class="yadokari-bold-pink">Point 3: チャットでQ&A</span><br>
        著者に対してYouTube Liveチャットからご質問いただけるQ&Aの時間もご用意。わからなかったところをしっかりと解消しましょう。<br>
        <img class="yadokari_creative" v-bind:src="require('../../../../static/img/yadokari_creative_3.png')"><br><br>

        <span class="yadokari-bold-pink">Point 4: 参加者特典</span><br>
        模試の後は復習が肝心です。スキマ時間を使ってしっかりと復習してもらえるよう、参加者全員にabceedアプリ版「標準模試 2（840円相当）」を無料でプレゼント！<br>
        <img class="yadokari_creative" v-bind:src="require('../../../../static/img/yadokari_creative_4.png')"><br><br>

        全国の学習者と5月のTOEIC本番直前を乗り切りましょう！<br><br>

        皆様のご参加を心よりお待ちしております！
      </main>

      <section class="unlimited-guide-base">
        <div>
          <section class="unlimited-types">
            <div class="unlimited-app-text">お申し込みにはabceedアカウントが必要です。<br>下記よりアプリをダウンロードしてアカウントを作成してください。</div>
            <div class="unlimited-footer-app-store">
              <a href="https://itunes.apple.com/jp/app/toeic-neng-li-fen-ximakushitoapuri/id1060016132?mt=8" target="_blank"><img src="/static/img/btn-install-apple.png" alt="app store" width="100"></a>
              <a href="https://play.google.com/store/apps/details?id=com.globee.abceedanalytics" target="_blank"><img src="/static/img/btn-install-google.png" alt="google store" width="100"></a>
            </div>
          </section>
        </div>
      </section>

      <section class="unlimited-guide unlimited-guide--fixed" v-if="fixedMenuShown">
        <div>
          <section class="unlimited-types">
            <div class="unlimited-app-text">お申し込みにはabceedアカウントが必要です。<br>下記よりアプリをダウンロードしてアカウントを作成してください。</div>
            <div class="unlimited-footer-app-store">
              <a href="https://itunes.apple.com/jp/app/toeic-neng-li-fen-ximakushitoapuri/id1060016132?mt=8" target="_blank"><img src="/static/img/btn-install-apple.png" alt="app store" width="100"></a>
              <a href="https://play.google.com/store/apps/details?id=com.globee.abceedanalytics" target="_blank"><img src="/static/img/btn-install-google.png" alt="google store" width="100"></a>
            </div>
          </section>
        </div>
      </section>
    </div>
</template>

<script>
  import $ from 'jquery';
  import {credit, subscriptions_prefix, unlimited_subscriptions_prefix, yadokari_event_product_id, yadokari_home_product_id } from '../../../constants';

  export default {
    title: 'やどかり全国模試',
    headerTitle: 'やどかり全国模試',
    headerType: 'historyBack',
    resetScrollView: true,
    components: {
    },
    data() {
      return {
        responseError: false,
        activeUnlimitedType: 1,
        fixedMenuShown: true,
        purchasedId: "",
        yadokari_event_product_id:yadokari_event_product_id,
        yadokari_home_product_id:yadokari_home_product_id,
        is_over_yadokari_moshi_event:false
      }
    },
    beforeRouteUpdate (to, from, next) {
      next();
    },
    created() {
      this.getStatus();
    },
    mounted() {
      this.setFixedContents();
    },
    methods: {
      separate(num) {
        return String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      },
      setFixedContents() {
        $(window).on("scroll", (e) => {
          let bodyScrollTop = $(e.target).scrollTop() + $(window).innerHeight();
          let startPosition = $(".unlimited-main").offset().top + $(".unlimited-main").outerHeight() + $(".unlimited-guide-base").outerHeight();
          if (bodyScrollTop > startPosition) {
            this.fixedMenuShown = false;
          } else {
            this.fixedMenuShown = true;
          }
        });
      }
    },
    computed: {

    }
  }
</script>

<style scoped lang="scss">

.yadokari_creative {
  width: 100%;
}

.unlimited-footer-app-store {
  width: 100%;
  padding-bottom: 10px;
}

.unlimited-app-text {
  width: 100%;
  font-weight: bold;
  font-size: 16px;
  padding: 10px;
}
.yadokari-bold-line {
  font-weight: bold;
  text-decoration: underline;
}

.yadokari-bold {
  font-weight: bold;
}

.yadokari-bold-pink {
  font-weight: bold;
  color: #FF4247;
  font-size: 18px;
}

.yadokari-title {
  padding-top: 10px;
  padding-left: 15px;
  padding-bottom: 10px;
  font-size: 22px;
  font-weight: bold;
  text-align: left;
}

.unlimited {
  background-color: white;
  width: 800px;
  margin: 0 auto;
  @media screen and (max-width: 768px){
    width: auto;
  }
}

.unlimited-keyvisual {
  position: relative;
  &__bg {
    width: 100%;
    height: auto;
  }
  &__contents {
    position: absolute;
    width: 800px;
    top: 60px;
    left: 50%;
    transform: translate(-50%, 0);
    @media screen and (max-width: 768px){
      top: 22px;
      width: 100%;
    }
  }
}

.unlimited-intro {
  &__title {
    font-size: 54px;
    font-weight: bold;
    margin-bottom: 4px;
    text-align: left;
    margin-left: 30px;
    @media screen and (max-width: 768px){
      font-size: 42px;
      line-height: 1.3;
      margin-left: 15px;
    }
  }
  &__subtitle {
    font-size: 24px;
    text-align: left;
    margin-left: 25px;
    @media screen and (max-width: 768px){
      font-size: 18px;
      margin-left: 10px;
    }
  }
}

.unlimited-types {
  align-items: center;
  background-color: white;
}

.unlimited-type {
  font-size: 14px;
  background-color: #fff;
  color: rgb(158, 158, 158);
  flex: 1;
  padding: 9px 0;
  line-height: 1.5;
  position: relative;
  &:hover {
    cursor: pointer;
  }
  &.is-active {
    color: #FF4247;
  }
  &__discount {
    position: absolute;
    height: 24px;
    line-height: 24px;
    top: -24px;
    left: 0;
    width: 100%;
    background-color: rgb(35, 25, 22);
    color: #fff;
  }
  &__title {
    font-size: 12px;
  }
  &__border {
    position: absolute;
    bottom: 5px;
    height: 3px;
    width: 66%;
    left: 17%;
    background-color: #FF4247;
  }
  &__bottom {
    font-size: 12px;
  }
}

.unlimited-discount-header {
  background-color: white;
  padding: 10px 0 0 0;
}

.unlimited-discount-top {
  font-size: 18px;
  color: #FF4247;
  font-weight: 500;
  margin: 0 10px;
}

.unlimited-discount-sub {
  font-size: 12px;
  text-align: left;
  margin: 0 15px;
  color: #757575;
}

.yadokari-purchased {
  background-color: #F1F1F1;
  text-align: left;
  padding: 10px 15px;
}

.yadokari-purchased_link {
  color: #FF4247;
  text-decoration: underline;
}

.video-wrapper {
  width:100%;
}
.video-player {
  background-attachment: fixed; // 中央揃えになるように、fixed。
  background-position: center center; // positionも中央に。
  background-size: cover; // 画面サイズに応じてサイズを可変するように設定。
  width:100%;
}
.unlimited-upgrade {
  background-color: #F1F1F1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  @media screen and (max-width: 768px){
    padding: 10px 10px;
  }
  &__title {
    width: calc(100% - 130px);
    text-align: left;
    font-size: 18px;
    margin-left: 10px;
    @media screen and (max-width: 768px){
      font-size: 14px;
    }
  }
  &__body {
    width: 130px;
  }
  .btn-upgrade {
    border-radius: 20px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #FF4247;
    padding: 8px 3px;
  }
}

.unlimited-guide {
  &--fixed {
    border-top: 1px solid #ebebeb;
    position: fixed;
    width: 800px;
    left: 50%;
    margin-left: -400px;
    bottom: 0;
    @media screen and (max-width: 768px){
      width: 100%;
      left: 0;
      margin: 0;
    }
  }
}

.unlimited-main {
  background-color: #fff;
  padding: 20px 100px;
  text-align: left;
  @media screen and (max-width: 768px){
    padding: 12px 15px;
  }
}

.unlimited-block {
  margin-bottom: 60px;
  @media screen and (max-width: 768px){
    margin-bottom: 30px;
  }
  &:last-of-type {
    margin-bottom: 0;
  }
  &__title {
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 10px;
    text-align: left;
    @media screen and (max-width: 768px){
      font-size: 21px;
    }
  }
}

.unlimited-tile-body {
  &__link {
    text-align: right;
    padding-top: 10px;
    @media screen and (max-width: 768px){
      padding-top: 6px;
    }
    a {
      color: #FF4247;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.unlimited-tile {
  border-radius: 8px;
  overflow: hidden;
  &__img {
    img {
      width: 100%;
    }
  }
  &__body {
    background-color: rgb(238, 238, 238);
    font-size: 21px;
    padding: 30px;
    text-align: left;
    @media screen and (max-width: 768px){
      font-size: 16px;
      padding: 12px;
    }
  }
}

.noneed-premium {
  padding: 30px 0 10px;
  @media screen and (max-width: 768px){
    padding: 20px 0 10px;
  }
  a {
    color: #FF4247;
    font-size: 18px;
    text-decoration: underline;
    @media screen and (max-width: 768px){
      font-size: 16px;
    }
    &:hover {
      text-decoration: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/campainPage/yadokari/LP.vue